<template>
  <body class="body">
    <div class="container">
      <div style="padding-bottom: 10px;">
        <p style="font-size: 18px;text-align: left;">Nume utilizator: <strong>{{user.name}}</strong> </p>
        <p style="font-size: 18px;text-align: left;">Adresa de e-mail: <strong>{{user.email}}</strong> </p>
      </div>

      <div style="overflow: auto;" v-if="resultsData.length > 0">
        <b-table
          :items="resultsData"
          :fields="fields"
          :sticky-header="true"
          :head-variant="'light'"
          :striped="true"
          :sort-by="'latest_date'"
          :sort-desc="true"></b-table>
      </div>

      <div class="center">
        <div>
          <button type="button" class="buton btn">
            <router-link style="text-decoration: none; color:black;" to="/stats">
              Statistici detaliate
            </router-link>
          </button>
        </div>
        <div>
          <button type="button" class="buton btn">
            <router-link style="text-decoration: none; color:black;" to="/general_stats">
              Statistici generale
            </router-link>
          </button>
        </div>
      </div>
    </div>
  </body>
</template>

<script>
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Profile',
  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },

  data:() => ({
    resultsData: [],

    fields: [
      {
        key: 'class',
        sortable: true,
        label: 'Clasa'
      },
      {
        key: 'chapter',
        sortable: true,
        label: 'Capitol'
      },
      {
        key: 'test',
        sortable: true,
        label: 'Test'
      },
      {
        key: 'result',
        sortable: true,
        label: 'Nota'
      },
      {
        key: 'time',
        sortable: true,
        label: 'Durata'
      },
      {
        key: 'latest_date',
        sortable: true,
        label: 'Data'
      }
    ],
  }),

  methods: {
    ...mapActions({
      sessionExpired: 'auth/sessionExpired'
    })
  },

  mounted() {
    axios.get('/results').then(response => {
      this.resultsData = response.data
    }).catch((e) => {
      if(e.response.status == 401){
        this.sessionExpired()
        alert('Sesiunea a expirat. Te rugăm să te autentifici din nou.')
        this.$router.replace({ name: 'login' })
      }
    })
  }
}
</script>

<style scoped>
.body {
 background-color: #FBEFDA;
 display: flex;
 align-content: center;
 justify-content: center;
 flex-direction: column;
 height: 100%;
}

.buton {
  text-align: center;
  border-radius:40px;
  background: #F7CCA1;
  border: 2px solid #F7CCA1;
  color:#F7CCA1;
  letter-spacing:1px;
  color: black;
  margin-top: 1%;
  width: fit-content;
}

.container {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 80%;
  height: fit-content;
  position: relative;
  -webkit-box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  text-align: center;
}

.center {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
}
</style>
